import { RouterState } from "connected-react-router";
import React, { memo } from "react";

import { useSelector }       from "react-redux";
import CalendarContainer     from "../../../containers/CalendarContainer";
import { ApplicationState }  from "../../../store";
import { Routes }            from "../../../types";
import {
  ExportUIComponent,
  PlaybackUIBackComponent,
  PlaybackUIForwardComponent
}                            from "../../ui";
import DatePickerUIComponent from "../../ui/DatePickerUIComponent/DatePickerUIComponent";

import LogoDateComponent from "../LogoDateComponent";


const CentralUIWrapperComponent = () => {
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const isBrowse = location.pathname === Routes.browse;
  const isBookmarks = location.pathname === Routes.bookmarks;
  const isAlerts = location.pathname === Routes.alerts;

  return (
    <>
      {isBrowse ? <DatePickerUIComponent/> : <div className='setData-wrapper flex js-c'>

      </div>}

      <CalendarContainer/>
      <div className='flex h-100'
           style={{alignItems: 'flexStart', paddingTop: '5px'}}
      >
        <div className="playback-controls">
          {(isBrowse || isBookmarks || isAlerts) && <PlaybackUIBackComponent/>}
        </div>
        <div className={'w-65px'}>

        </div>

        <LogoDateComponent/>

        <div className="playback-controls">
          {(isBrowse || isBookmarks || isAlerts) && <PlaybackUIForwardComponent/>}
        </div>
      </div>


      {(isBrowse || isBookmarks) && <ExportUIComponent/>}
      {isAlerts && <div className='setData-wrapper flex js-c'>

      </div>}
    </>
  )
};

export default memo(CentralUIWrapperComponent);